"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMapFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M15 5.365v14.608a5.632 5.632 0 01-.684-.113L9 18.606V4.009c.28.026.614.089 1 .188l4.95 1.182.05-.014zm2-.574l2.469-.709a2.09 2.09 0 011.792.302c.47.34.739.851.739 1.4v11.338c0 .783-.548 1.467-1.364 1.702L17 19.736V4.791zM7 19.19l-2.469.721c-.19.054-.386.082-.584.082-.433 0-.86-.132-1.208-.385-.47-.34-.739-.85-.739-1.4V7.082c0-.785.548-1.469 1.365-1.703L7 4.33V19.19z' }))); };
exports.default = SvgMapFilled;
//# sourceMappingURL=MapFilled.js.map